import React, { useEffect, useState } from 'react';
import Button from '../ui/Button';
import { useSignatureService } from '../../services/api/signatureService';
import { colors, spacing, radius, typography } from '../../theme/tokens';

/**
 * Banner de reanudación de firma masiva (F1D-5). Al montarse, consulta los lotes activos del
 * firmante; si hay uno sin terminar, ofrece reanudarlo o descartarlo.
 *
 * @param {(sel:{resumeBatchId:number, count:number}) => void} onResume
 * @param {(sel:{batchId:number}) => Promise<void>} [onCancel]
 */
const BatchResumeBanner = ({ onResume, onCancel }) => {
  const signatureService = useSignatureService();
  const [batch, setBatch] = useState(null);

  useEffect(() => {
    let alive = true;
    signatureService.listActiveBatches()
      .then((res) => { if (alive) setBatch((res?.data || [])[0] || null); })
      .catch(() => {});
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!batch) return null;

  const handleCancel = async () => {
    try {
      await onCancel?.({ batchId: batch.batchId });
    } finally {
      setBatch(null);
    }
  };

  return (
    <div style={styles.banner}>
      <span>
        Tenés un lote de firma sin terminar ({batch.assembledCount || 0} firmados, {batch.failedCount || 0} fallidos de {batch.totalDocuments}).
      </span>
      <div style={{ display: 'flex', gap: spacing[2] }}>
        <Button variant="ghost" onClick={handleCancel}>Descartar lote</Button>
        <Button variant="primary" onClick={() => onResume({ resumeBatchId: batch.batchId, count: batch.totalDocuments })}>
          Reanudar
        </Button>
      </div>
    </div>
  );
};

const styles = {
  banner: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: spacing[3],
    padding: spacing[3], marginBottom: spacing[3], borderRadius: radius.sm,
    backgroundColor: colors.warningBg, color: colors.warningDark, fontSize: typography.fontSize.base,
  },
};

export default BatchResumeBanner;
